import { AxiosRequestConfig } from 'axios'

import { CreatePrizePayload, UpdatePrizeData } from './types'

const getPrizes = (): AxiosRequestConfig => ({
  url: '/prizes',
  method: 'GET',
})

const createPrize = (prize: CreatePrizePayload): AxiosRequestConfig => {
  const payload = new FormData()
  const {
    title,
    shortTitle,
    icon,
    image,
    level,
    welcomePrize,
    birthdayPrize,
    additionalText,
    membershipId,
    rewardType,
    pushTitle,
    pushDescription,
    pushMessage,
    expirationDays,
    category,
    storesEnabled,
    tucanEnabled,
    toteatEnabled,
    skus,
    toteatBenefitId,
    description,
  } = prize
  payload.append('title', title)
  payload.append('shortTitle', shortTitle)
  payload.append('icon', icon)
  payload.append('image', image)
  if (level) payload.append('level', level.toString())
  if (welcomePrize) payload.append('welcomePrize', welcomePrize.toString())
  if (birthdayPrize) payload.append('birthdayPrize', birthdayPrize.toString())
  if (additionalText) payload.append('additionalText', additionalText)
  if (membershipId) payload.append('membershipId', membershipId.toString())
  if (rewardType) payload.append('rewardType', rewardType)
  if (pushTitle) payload.append('pushTitle', pushTitle)
  if (pushDescription) payload.append('pushDescription', pushDescription)
  if (pushMessage) payload.append('pushMessage', pushMessage.toString())
  if (expirationDays) payload.append('expirationDays', expirationDays.toString())
  if (category) payload.append('category', category)
  payload.append('storesEnabled', storesEnabled.toString())
  payload.append('tucanEnabled', tucanEnabled.toString())
  payload.append('toteatEnabled', toteatEnabled.toString())
  if (skus) payload.append('skus', skus.join(','))
  if (toteatBenefitId) payload.append('toteatBenefitId', toteatBenefitId)
  if (description) payload.append('description', description)

  return {
    url: '/prizes',
    method: 'POST',
    data: payload,
  }
}

const updatePrize = (data: UpdatePrizeData): AxiosRequestConfig => {
  const payload = new FormData()
  const {
    title,
    shortTitle,
    icon,
    image,
    active,
    level,
    welcomePrize,
    birthdayPrize,
    additionalText,
    rewardType,
    pushTitle,
    pushDescription,
    pushMessage,
    expirationDays,
    category,
    storesEnabled,
    tucanEnabled,
    toteatEnabled,
    skus,
    toteatBenefitId,
    description,
  } = data.payload
  if (title) payload.append('title', title)
  if (shortTitle) payload.append('shortTitle', shortTitle)
  if (icon) payload.append('icon', icon)
  if (image) payload.append('image', image)
  if (active !== undefined) payload.append('active', active.toString())
  if (level) payload.append('level', level.toString())
  if (welcomePrize) payload.append('welcomePrize', true.toString())
  if (birthdayPrize) payload.append('birthdayPrize', birthdayPrize.toString())
  if (additionalText) payload.append('additionalText', additionalText)
  if (rewardType) payload.append('rewardType', rewardType)
  if (pushTitle) payload.append('pushTitle', pushTitle)
  if (pushDescription) payload.append('pushDescription', pushDescription)
  if (pushMessage !== undefined) payload.append('pushMessage', pushMessage.toString())
  if (expirationDays) payload.append('expirationDays', expirationDays.toString())
  if (category) payload.append('category', category)
  payload.append('storesEnabled', storesEnabled ? 'true' : 'false')
  payload.append('tucanEnabled', tucanEnabled ? 'true' : 'false')
  payload.append('toteatEnabled', toteatEnabled ? 'true' : 'false')
  if (skus) payload.append('skus', skus.join(','))
  if (toteatBenefitId) payload.append('toteatBenefitId', toteatBenefitId)
  if (description) payload.append('description', description)

  return {
    url: `/prizes/${data.id}`,
    method: 'PUT',
    data: payload,
  }
}

const deletePrize = (id: number): AxiosRequestConfig => ({
  url: `/prizes/${id}`,
  method: 'DELETE',
})

export { getPrizes, createPrize, updatePrize, deletePrize }
